var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenerateCode(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 468 414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -33.214,
    y1: 0.5,
    x2: -32.214,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f28ac0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0658a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -6.016,
    y1: -0.106,
    x2: -5.867,
    y2: 1.093,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#131e44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#111761"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -25.233,
    y1: 0.499,
    x2: -24.236,
    y2: 0.499,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "generate-code",
    transform: "translate(-150 -976)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1128",
    "data-name": "Rectangle 1128",
    width: 468,
    height: 414,
    transform: "translate(150 976)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(150 976.066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble",
    "data-name": "Speech Bubble",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_901",
    "data-name": "Rectangle 901",
    width: 95.017,
    height: 179.614,
    transform: "translate(58.707 187.94)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_902",
    "data-name": "Rectangle 902",
    width: 95.017,
    height: 179.614,
    transform: "translate(30.511 187.94)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2040",
    "data-name": "Path 2040",
    d: "M126.372,266.738H44.81V238.27h81.562Zm-80.581-1h79.551V239.276H45.791Z",
    transform: "translate(-7.836 -41.829)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2041",
    "data-name": "Path 2041",
    d: "M76.17,238.88h30.95v2.168a3.5,3.5,0,0,1-3.5,3.5H79.707a3.5,3.5,0,0,1-3.5-3.5V238.88Z",
    transform: "translate(-13.341 -41.937)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2042",
    "data-name": "Path 2042",
    d: "M126.372,310.608H44.81V282.14h81.562Zm-80.581-1h79.551V283.138H45.791Z",
    transform: "translate(-7.836 -49.531)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2043",
    "data-name": "Path 2043",
    d: "M76.17,282.75h30.95v2.168a3.5,3.5,0,0,1-3.5,3.5H79.707a3.5,3.5,0,0,1-3.5-3.5V282.75Z",
    transform: "translate(-13.341 -49.638)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2044",
    "data-name": "Path 2044",
    d: "M126.372,354.476H44.81V326h81.562Zm-80.581-1h79.551V327.006H45.791Z",
    transform: "translate(-7.836 -57.231)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2045",
    "data-name": "Path 2045",
    d: "M76.17,326.61h30.95v2.168a3.5,3.5,0,0,1-3.5,3.5H79.707a3.5,3.5,0,0,1-3.5-3.5V326.61Z",
    transform: "translate(-13.341 -57.338)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2046",
    "data-name": "Path 2046",
    d: "M126.372,398.346H44.81V369.87h81.562Zm-80.581-1.006h79.551V370.876H45.791Z",
    transform: "translate(-7.836 -64.933)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2047",
    "data-name": "Path 2047",
    d: "M76.17,370.48h30.95v2.168a3.5,3.5,0,0,1-3.5,3.5H79.707a3.5,3.5,0,0,1-3.5-3.5V370.48Z",
    transform: "translate(-13.341 -65.04)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_903",
    "data-name": "Rectangle 903",
    width: 103.212,
    height: 8.945,
    transform: "translate(26.298 181.221)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_904",
    "data-name": "Rectangle 904",
    width: 31.032,
    height: 8.945,
    transform: "translate(129.502 181.221)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_905",
    "data-name": "Rectangle 905",
    width: 4.996,
    height: 9.176,
    transform: "translate(30.511 367.554)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_906",
    "data-name": "Rectangle 906",
    width: 4.996,
    height: 9.176,
    transform: "translate(61.361 367.554)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_907",
    "data-name": "Rectangle 907",
    width: 4.996,
    height: 9.176,
    transform: "translate(117.72 367.554)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_908",
    "data-name": "Rectangle 908",
    width: 4.996,
    height: 9.176,
    transform: "translate(145.9 367.554)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2048",
    "data-name": "Path 2048",
    d: "M106,190.56l9.621,24.61-5.977-.033-4.79-15.12Z",
    transform: "translate(-18.376 -33.454)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2049",
    "data-name": "Path 2049",
    d: "M65.706,162.99,62.4,210.132l34.132.717,3.842-47.859Z",
    transform: "translate(-10.924 -28.614)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2050",
    "data-name": "Path 2050",
    d: "M69.964,167.541,67.21,206.784l25.376,1.187,3.545-40.662Z",
    transform: "translate(-11.768 -29.372)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2051",
    "data-name": "Path 2051",
    d: "M76.863,174.32,74.81,201.906H88.8l2.473-27.586Z",
    transform: "translate(-13.102 -30.603)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_909",
    "data-name": "Rectangle 909",
    width: 110.162,
    height: 108.241,
    transform: "translate(134.119)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_910",
    "data-name": "Rectangle 910",
    width: 102.446,
    height: 102.446,
    transform: "translate(137.952 2.96)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_911",
    "data-name": "Rectangle 911",
    width: 33.423,
    height: 33.423,
    transform: "translate(172.464 37.471)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2052",
    "data-name": "Path 2052",
    d: "M327.332,12.08c-1.245,17.767,0,50.844-6.464,67.431s-15.1,33.67-31.288,41.09c-19.927,9.135-43.349,5.268-64.612,10.619-33.332,8.385-57.423,38.963-67.712,71.727s-9.16,67.942-7.906,102.289l170.091,23.6s.89-69.113,15.73-87.977,85.3-35.839,108.579-87.5c20.933-46.49,27.264-120.221,27.264-120.221Z",
    transform: "translate(-26.049 -2.121)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2053",
    "data-name": "Path 2053",
    d: "M449.177,101.111c0,.239-15.524-1.649-34.627-4.279s-34.536-4.889-34.47-5.136,15.524,1.649,34.627,4.287S449.21,100.88,449.177,101.111Z",
    transform: "translate(-66.694 -16.094)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2054",
    "data-name": "Path 2054",
    d: "M446.923,117.911c0,.231-15.533-1.649-34.627-4.287s-34.52-4.9-34.487-5.128,15.524,1.649,34.627,4.279S446.956,117.68,446.923,117.911Z",
    transform: "translate(-66.296 -19.044)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2055",
    "data-name": "Path 2055",
    d: "M439.281,135.039c0,.231-15.524-1.69-34.627-4.287s-34.528-4.9-34.495-5.136,15.524,1.649,34.627,4.287S439.281,134.8,439.281,135.039Z",
    transform: "translate(-64.953 -22.049)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2056",
    "data-name": "Path 2056",
    d: "M425.281,152.319c0,.231-15.524-1.69-34.627-4.287s-34.528-4.9-34.495-5.136,15.524,1.649,34.627,4.287S425.281,152.047,425.281,152.319Z",
    transform: "translate(-62.495 -25.082)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2057",
    "data-name": "Path 2057",
    d: "M402.971,169.561c0,.231-15.524-1.649-34.627-4.287s-34.528-4.9-34.495-5.128,15.524,1.649,34.627,4.279S403,169.322,402.971,169.561Z",
    transform: "translate(-58.578 -28.111)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2058",
    "data-name": "Path 2058",
    d: "M497.876,108.122c-.041.239-3.842-.19-8.508-.948s-8.368-1.566-8.368-1.8,3.85.19,8.508.948S497.918,107.891,497.876,108.122Z",
    transform: "translate(-84.411 -18.488)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2059",
    "data-name": "Path 2059",
    d: "M453.283,83.991c0,.231-15.533-1.649-34.627-4.287s-34.519-4.9-34.487-5.128,15.524,1.649,34.627,4.279S453.333,83.752,453.283,83.991Z",
    transform: "translate(-67.412 -13.089)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2060",
    "data-name": "Path 2060",
    d: "M502,91c0,.231-3.842-.19-8.5-.948s-8.409-1.566-8.368-1.8,3.842.19,8.5.948S502.039,90.771,502,91Z",
    transform: "translate(-85.136 -15.483)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2061",
    "data-name": "Path 2061",
    d: "M457.963,66.861c0,.239-15.533-1.649-34.627-4.279s-34.52-4.9-34.487-5.136,15.516,1.649,34.627,4.287S457.988,66.63,457.963,66.861Z",
    transform: "translate(-68.234 -10.081)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2062",
    "data-name": "Path 2062",
    d: "M506.656,73.872c0,.239-3.842-.19-8.5-.948s-8.409-1.566-8.376-1.8,3.85.19,8.508.956S506.7,73.641,506.656,73.872Z",
    transform: "translate(-85.952 -12.476)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2063",
    "data-name": "Path 2063",
    d: "M460.147,49.741c0,.231-15.524-1.649-34.627-4.287s-34.511-4.9-34.47-5.128,15.524,1.649,34.627,4.279S460.18,49.5,460.147,49.741Z",
    transform: "translate(-68.62 -7.076)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2064",
    "data-name": "Path 2064",
    d: "M508.851,56.747c-.041.231-3.85-.19-8.508-.948s-8.409-1.566-8.343-1.814,3.842.19,8.508.948S508.884,56.516,508.851,56.747Z",
    transform: "translate(-86.342 -9.465)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2065",
    "data-name": "Path 2065",
    d: "M497.146,123.1c-.041.231-3.85-.2-8.508-.956s-8.409-1.558-8.368-1.8,3.85.2,8.508.956S497.188,122.861,497.146,123.1Z",
    transform: "translate(-84.283 -21.116)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2066",
    "data-name": "Path 2066",
    d: "M492.066,143.816c-.041.231-3.85-.214-8.517-.989s-8.451-1.583-8.36-1.756c0-.3,3.85.148,8.5.915S492.107,143.585,492.066,143.816Z",
    transform: "translate(-83.391 -24.749)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2067",
    "data-name": "Path 2067",
    d: "M484.726,161.406c-.041.239-3.85-.214-8.516-.981s-8.451-1.591-8.36-1.764,3.85.148,8.5.915S484.767,161.134,484.726,161.406Z",
    transform: "translate(-82.102 -27.846)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2068",
    "data-name": "Path 2068",
    d: "M468.946,178.026c-.041.231-3.858-.214-8.517-.989s-8.451-1.583-8.36-1.756,3.842.148,8.5.915S468.987,177.795,468.946,178.026Z",
    transform: "translate(-79.332 -30.763)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2069",
    "data-name": "Path 2069",
    d: "M376.545,189.511c0,.239-23.291-2.861-51.94-6.917s-51.858-7.535-51.825-7.766,23.282,2.861,51.94,6.917S376.578,189.28,376.545,189.511Z",
    transform: "translate(-47.857 -30.69)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2070",
    "data-name": "Path 2070",
    d: "M360.259,206.486a5.26,5.26,0,0,1-1.154-.091l-3.3-.429-12-1.748-39.573-6.1c-15.442-2.473-29.416-4.691-39.524-6.381l-11.954-2.069c-1.41-.256-2.473-.462-3.24-.618a6.593,6.593,0,0,1-1.121-.289,6.908,6.908,0,0,1,1.154.115l3.3.462,12,1.8,39.573,6.142,39.516,6.34,11.971,2.02,3.24.594A6.693,6.693,0,0,1,360.259,206.486Z",
    transform: "translate(-43.575 -33.138)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2071",
    "data-name": "Path 2071",
    d: "M334.387,222.786c.148.148-1.525,0-4.279-.371s-6.818-.915-11.79-1.649c-9.951-1.443-23.678-3.529-38.831-5.895s-28.856-4.576-38.79-6.225l-11.74-1.987-3.182-.585a6.44,6.44,0,0,1-1.1-.256,5.036,5.036,0,0,1,1.13.091l3.207.42,11.781,1.723,38.831,5.969,38.79,6.15Z",
    transform: "translate(-39.411 -36.132)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2072",
    "data-name": "Path 2072",
    d: "M442.586,201.725c-.041.231-3.858-.214-8.525-.989s-8.442-1.583-8.352-1.756c0-.3,3.842.14,8.492.915S442.619,201.495,442.586,201.725Z",
    transform: "translate(-74.704 -34.916)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2073",
    "data-name": "Path 2073",
    d: "M422.256,213.043c-.041.231-3.858-.214-8.517-.989s-8.451-1.583-8.36-1.764,3.842.148,8.5.915S422.3,212.8,422.256,213.043Z",
    transform: "translate(-71.135 -36.909)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2074",
    "data-name": "Path 2074",
    d: "M394.888,232.1c0,.231-3.85-.214-8.516-.989s-8.442-1.583-8.352-1.756c0-.3,3.842.14,8.492.915S394.929,231.865,394.888,232.1Z",
    transform: "translate(-66.332 -40.247)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2075",
    "data-name": "Path 2075",
    d: "M318.854,258.575c-.041.231-28.79-4-64.208-9.448s-64.109-10.058-64.076-10.289,28.781,4,64.208,9.448S318.887,258.344,318.854,258.575Z",
    transform: "translate(-33.425 -41.928)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2076",
    "data-name": "Path 2076",
    d: "M316.346,299.069c0,.239-9.456-1.1-21.04-2.968s-20.949-3.578-20.916-3.817,9.465,1.1,21.048,2.976S316.387,298.838,316.346,299.069Z",
    transform: "translate(-48.14 -51.307)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2077",
    "data-name": "Path 2077",
    d: "M445.8,189.62c-4.765.1-7.643,5.54-7.882,10.3s1.047,9.63-.124,14.246c-1.484,5.87-6.686,10.281-8.038,16.176-1.591,6.958,2.515,13.9,3.05,21.015.256,3.463-.338,7.008.47,10.38a12.771,12.771,0,0,0,25.038-.973c.824-5.392-1.773-10.949-.618-16.283.824-3.949,3.71-7.42,3.759-11.435.066-4.807-3.842-8.764-4.765-13.48s1.253-9.465,1.377-14.263c.223-8.615-3.661-15.186-12.268-15.664",
    transform: "translate(-75.35 -33.289)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2078",
    "data-name": "Path 2078",
    d: "M451.081,216.9a4.384,4.384,0,0,1,0,.758c0,.544-.082,1.27-.14,2.193-.14,1.937-.346,4.666-.594,8.03-.511,6.785-1.2,16.159-1.9,26.514s-1.278,19.737-1.69,26.531c-.206,3.364-.371,6.1-.495,8.038-.058.915-.115,1.649-.148,2.185a4.938,4.938,0,0,1-.082.759,4.849,4.849,0,0,1,0-.759c0-.544.041-1.27.066-2.193.082-1.946.206-4.683.355-8.047.33-6.8.824-16.184,1.558-26.547s1.443-19.729,2.028-26.506c.313-3.355.561-6.084.742-8.022.091-.915.173-1.649.223-2.185A4.056,4.056,0,0,1,451.081,216.9Z",
    transform: "translate(-78.269 -38.078)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2079",
    "data-name": "Path 2079",
    d: "M444.853,322.906h0a15.211,15.211,0,0,0,15.2-15.2V292.5H429.65v15.2a15.211,15.211,0,0,0,15.2,15.2Z",
    transform: "translate(-75.396 -51.35)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2080",
    "data-name": "Path 2080",
    d: "M429.65,301.51a2.118,2.118,0,0,1,.5.33l1.327,1.039,4.7,3.809h-.247l8.764-5.375h0l.14-.082.132.091,8.162,5.375h-.256l5.153-3.8,1.459-1.039a2.343,2.343,0,0,1,.544-.33,4.367,4.367,0,0,1-.462.437l-1.385,1.129-5.046,3.957-.124.091-.132-.082-8.195-5.309h.256l-8.813,5.3-.132.082-.115-.1-4.584-3.957-1.261-1.121A2.8,2.8,0,0,1,429.65,301.51Z",
    transform: "translate(-75.396 -52.882)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2081",
    "data-name": "Path 2081",
    d: "M429.65,297.822a2.034,2.034,0,0,1,.5.338l1.327,1.031,4.7,3.809h-.247l8.764-5.367h0l.14-.082.132.091,8.162,5.375h-.256l5.153-3.8,1.459-1.039a2.344,2.344,0,0,1,.544-.33,4.361,4.361,0,0,1-.462.437l-1.385,1.138-5.046,3.949-.124.1-.132-.091-8.195-5.309h.272l-8.813,5.293-.132.082-.115-.1-4.584-3.949-1.261-1.13C429.782,298,429.633,297.839,429.65,297.822Z",
    transform: "translate(-75.396 -52.236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2082",
    "data-name": "Path 2082",
    d: "M429.65,305.26a2.119,2.119,0,0,1,.5.33l1.327,1.039,4.7,3.809h-.247l8.764-5.375h0l.14-.082.132.091,8.162,5.375h-.256l5.178-3.8,1.459-1.039a2.342,2.342,0,0,1,.544-.33,4.35,4.35,0,0,1-.462.437l-1.385,1.129-5.046,3.957-.124.091-.132-.082-8.195-5.309h.256l-8.813,5.268-.132.082-.115-.1-4.584-3.957-1.261-1.121C429.782,305.425,429.633,305.277,429.65,305.26Z",
    transform: "translate(-75.396 -53.541)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2083",
    "data-name": "Path 2083",
    d: "M471.7,422.51l9.712,27.833h-4.856L459.56,422.51Z",
    transform: "translate(-80.647 -74.174)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2084",
    "data-name": "Path 2084",
    d: "M404.682,422.51l-9.712,27.833h4.856L416.81,422.51Z",
    transform: "translate(-69.308 -74.174)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_912",
    "data-name": "Rectangle 912",
    width: 77.547,
    height: 77.547,
    transform: "translate(389.837 349.037) rotate(180)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_913",
    "data-name": "Rectangle 913",
    width: 77.547,
    height: 77.547,
    transform: "translate(414.133 349.037) rotate(180)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2085",
    "data-name": "Path 2085",
    d: "M481.738,403.229H414.43v-67.3h67.308Zm-66.3-1h65.3v-65.3h-65.3Z",
    transform: "translate(-72.724 -58.974)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2086",
    "data-name": "Path 2086",
    d: "M480.908,361.181c-21.889-.635-44.017-.47-65.914,0a.264.264,0,1,0,0,.528c21.9.445,44.025.61,65.914,0a.239.239,0,0,0,0-.47Z",
    transform: "translate(-72.777 -63.334)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2087",
    "data-name": "Path 2087",
    d: "M453,349.318a1.88,1.88,0,1,0,.55-1.337A1.888,1.888,0,0,0,453,349.318Z",
    transform: "translate(-79.496 -60.993)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2088",
    "data-name": "Path 2088",
    d: "M485.94,386.058a1.88,1.88,0,1,0,.551-1.337,1.888,1.888,0,0,0-.551,1.337Z",
    transform: "translate(-85.278 -67.443)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2089",
    "data-name": "Path 2089",
    d: "M250.787,438.148,105.141,272.2a12.367,12.367,0,0,1,1.138-17.5l101.407-88.982a12.367,12.367,0,0,1,17.5,1.138l145.63,165.919a12.367,12.367,0,0,1-1.138,17.5L268.273,439.253a12.367,12.367,0,0,1-17.486-1.1Z",
    transform: "translate(-17.883 -28.548)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2090",
    "data-name": "Path 2090",
    d: "M369.168,370.759a16.951,16.951,0,1,1,1.558-23.909A16.951,16.951,0,0,1,369.168,370.759Z",
    transform: "translate(-59.839 -59.877)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2091",
    "data-name": "Path 2091",
    d: "M377.338,394.008a18.33,18.33,0,0,1-4.312.239,17.684,17.684,0,1,1,4.312-.239Zm-6.027-33.374a16.134,16.134,0,1,0,13.5,28.031h0a16.134,16.134,0,0,0-9.588-28.221A16.745,16.745,0,0,0,371.312,360.634Z",
    transform: "translate(-62.559 -63.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2092",
    "data-name": "Path 2092",
    d: "M163.461,257.411l-10.248,8.995-.923-1.055,9.308-8.162-2.127-2.424.932-.824Z",
    transform: "translate(-26.704 -44.58)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2093",
    "data-name": "Path 2093",
    d: "M164.222,277.776l-.932.824L157,271.411l.742-.66,7.906.6c2.16.148,3.042-.231,3.743-.824,1.187-1.039,1.187-2.473-.19-4.081a4.617,4.617,0,0,0-3.595-1.8V263.34a6.142,6.142,0,0,1,4.65,2.35c1.822,2.078,1.921,4.32.214,5.821-.981.824-2.127,1.327-4.683,1.129l-6.48-.478Z",
    transform: "translate(-27.531 -46.231)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2094",
    "data-name": "Path 2094",
    d: "M177.719,289.916l-1.806-2.053-2.688,2.366-.923-1.055,2.688-2.358-5.07-5.771.758-.668,11.542-.528,1.022,1.171-11.212.569,3.908,4.444,2.374-2.078.9,1.022-2.374,2.078,1.8,2.053Z",
    transform: "translate(-29.799 -49.129)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2095",
    "data-name": "Path 2095",
    d: "M194.431,308.965l-1.8-2.053-2.688,2.366-.932-1.055,2.7-2.366-5.07-5.771.758-.668,11.542-.528,1.031,1.171-11.212.569,3.908,4.444L195.033,303l.9,1.022-2.366,2.078,1.8,2.053Z",
    transform: "translate(-32.735 -52.472)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2096",
    "data-name": "Path 2096",
    d: "M204.239,318.97c-1.74,1.525-4.172,1.509-6.365-1a7.016,7.016,0,0,1-1.9-4.823l1.278-.223a5.9,5.9,0,0,0,1.583,4.188c1.525,1.74,3.182,1.921,4.427.824s1.418-2.7-.866-5.3l-1.921-2.177,5.6-3.982,4.947,5.606-.932.824-4.122-4.683-3.57,2.515,1.154,1.319C206.259,315.153,206.069,317.379,204.239,318.97Z",
    transform: "translate(-34.373 -53.804)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2097",
    "data-name": "Path 2097",
    d: "M215.216,331.4c-1.913,1.649-4.469,1.253-6.216-.742-2.383-2.721-1.8-5.854,1.435-8.7,3.487-3.05,6.975-2.745,9.415.041a6.241,6.241,0,0,1,1.575,2.91l-1.22.33a4.8,4.8,0,0,0-1.27-2.416c-1.937-2.21-4.6-2.383-7.42.058a9.727,9.727,0,0,0-.824.775,4.337,4.337,0,0,1,4.5,1.591C217.047,327.276,217.1,329.749,215.216,331.4Zm-.94-1.014c1.352-1.179,1.336-2.935-.049-4.518s-3.3-1.789-4.551-.668c-1.129.989-1.377,2.861.181,4.633,1.3,1.476,3.059,1.748,4.419.552Z",
    transform: "translate(-36.404 -56.14)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2098",
    "data-name": "Path 2098",
    d: "M229.891,348.149c-1.715,1.5-4.122,1.41-6.291-1.064a7.041,7.041,0,0,1-1.921-4.839l1.286-.223a5.953,5.953,0,0,0,1.6,4.221c1.492,1.7,3.1,1.937,4.37.824s1.278-2.646-.387-4.543l-.643-.734.775-.684,6.051-.28-4.6-5.243.932-.824,5.771,6.6-.75.66-6.183.3C231.722,344.6,231.532,346.706,229.891,348.149Z",
    transform: "translate(-38.886 -58.769)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2099",
    "data-name": "Path 2099",
    d: "M241.085,360.86c-1.921,1.649-4.468,1.261-6.216-.734-2.391-2.721-1.806-5.854,1.435-8.7,3.479-3.05,6.967-2.745,9.407.041a6.167,6.167,0,0,1,1.575,2.91l-1.22.33a4.782,4.782,0,0,0-1.261-2.416c-1.937-2.218-4.609-2.383-7.42.049-.239.214-.511.478-.824.783a4.353,4.353,0,0,1,4.51,1.583C242.907,356.746,242.965,359.219,241.085,360.86Zm-.948-1.014c1.352-1.179,1.344-2.927-.049-4.51s-3.3-1.789-4.551-.668c-1.121.989-1.369,2.861.181,4.633,1.3,1.476,3.059,1.74,4.419.544Z",
    transform: "translate(-40.945 -61.314)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2100",
    "data-name": "Path 2100",
    d: "M258.273,365.519l-.75.651-13.257,4.048-1.006-1.138,13.01-3.957-4.625-5.268-1.921,1.649-.907-1.031L251.669,358Z",
    transform: "translate(-42.675 -62.849)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2101",
    "data-name": "Path 2101",
    d: "M273.865,383.284l-.742.651-13.265,4.048-1-1.138,13-3.957L267.22,377.6l-1.913,1.649-.915-1.039,2.853-2.473Z",
    transform: "translate(-45.413 -65.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2102",
    "data-name": "Path 2102",
    d: "M277.086,402.32c-1.814,1.591-4.287,1.047-6.431-1.4s-2.341-4.947-.528-6.53a3.4,3.4,0,0,1,4.254-.239,3.083,3.083,0,0,1,.824-3.586c1.649-1.459,3.957-.956,5.862,1.212s2.135,4.526.462,5.985a3.084,3.084,0,0,1-3.694.346,3.421,3.421,0,0,1-.75,4.213Zm-.932-1.1c1.253-1.1,1.1-2.886-.495-4.7s-3.3-2.185-4.584-1.08-1.121,2.877.47,4.691,3.331,2.185,4.609,1.08Zm.338-5.433c1.4,1.6,2.951,1.921,4.064.94s.973-2.638-.379-4.172-2.919-1.921-4.065-.915-1.022,2.548.379,4.139Z",
    transform: "translate(-47.175 -68.42)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2103",
    "data-name": "Path 2103",
    d: "M289.957,412.328c-3.487,3.059-6.975,2.745-9.407,0A6.249,6.249,0,0,1,279,409.4l1.22-.322a4.831,4.831,0,0,0,1.27,2.416c1.937,2.209,4.6,2.383,7.379-.058.239-.206.519-.478.824-.775a4.353,4.353,0,0,1-4.5-1.591c-1.789-2.036-1.839-4.51.041-6.15s4.468-1.253,6.216.734C293.782,406.351,293.189,409.492,289.957,412.328Zm.759-3.232c1.129-.989,1.377-2.869-.181-4.642-1.294-1.476-3.059-1.74-4.419-.544s-1.336,2.935.049,4.518,3.281,1.8,4.551.668Z",
    transform: "translate(-48.949 -70.555)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2104",
    "data-name": "Path 2104",
    d: "M307.068,421.059,296.8,430.046l-.923-1.055,9.308-8.17-2.127-2.416.94-.824Z",
    transform: "translate(-51.912 -73.308)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2105",
    "data-name": "Path 2105",
    d: "M307.839,441.42l-.932.824-6.307-7.181.742-.66,7.906.6c2.16.148,3.042-.231,3.743-.824,1.187-1.039,1.187-2.515-.19-4.081a4.617,4.617,0,0,0-3.595-1.8V427a6.142,6.142,0,0,1,4.65,2.35c1.822,2.078,1.921,4.32.206,5.821-.973.824-2.127,1.327-4.683,1.129l-6.48-.478Z",
    transform: "translate(-52.741 -74.962)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2106",
    "data-name": "Path 2106",
    d: "M319.852,450.647c-1.715,1.5-4.122,1.41-6.291-1.064a7.041,7.041,0,0,1-1.921-4.839l1.278-.223a6,6,0,0,0,1.608,4.221c1.492,1.7,3.1,1.937,4.37.824s1.286-2.63-.363-4.559l-.643-.734.775-.676,6.043-.28-4.592-5.243.932-.824,5.771,6.6-.742.66-6.192.3C321.682,447.094,321.492,449.2,319.852,450.647Z",
    transform: "translate(-54.679 -76.761)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_914",
    "data-name": "Rectangle 914",
    width: 5.92,
    height: 109.206,
    transform: "matrix(0.751, -0.66, 0.66, 0.751, 181.035, 308.211)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_915",
    "data-name": "Rectangle 915",
    width: 5.92,
    height: 56.013,
    transform: "translate(207.235 356.043) rotate(-41.27)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_916",
    "data-name": "Rectangle 916",
    width: 45.823,
    height: 34.231,
    rx: 4.96,
    transform: "translate(165.735 176.15) rotate(48.73)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2107",
    "data-name": "Path 2107",
    d: "M178.42,231.457l1.649-1.443,15.566,17.734a4.947,4.947,0,1,0,7.42-6.521L187.5,223.493l1.649-1.443L204.7,239.784a7.131,7.131,0,1,1-10.719,9.408Z",
    transform: "translate(-31.292 -38.982)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_917",
    "data-name": "Rectangle 917",
    width: 2.193,
    height: 16.192,
    transform: "translate(171.214 210.767) rotate(-41.22)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_918",
    "data-name": "Rectangle 918",
    width: 117.846,
    height: 10.116,
    transform: "translate(190.481 161.64) rotate(48.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2108",
    "data-name": "Path 2108",
    d: "M290.481,373.77H255v31.576L244.7,423.69h56.087l-10.306-18.344Z",
    transform: "translate(-42.927 -65.617)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_919",
    "data-name": "Rectangle 919",
    width: 286.445,
    height: 186.3,
    rx: 14.77,
    transform: "translate(87.521 126.223)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_920",
    "data-name": "Rectangle 920",
    width: 85.858,
    height: 9.019,
    transform: "translate(186.883 358.073)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2109",
    "data-name": "Path 2109",
    d: "M187.422,165.94V331.076h-57.8a13.191,13.191,0,0,1-13.15-13.142V179.082a13.191,13.191,0,0,1,13.15-13.142Z",
    transform: "translate(-20.416 -29.132)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2110",
    "data-name": "Path 2110",
    d: "M400.93,179.082V317.935a13.142,13.142,0,0,1-13.142,13.142H202.47V165.94H387.789a13.133,13.133,0,0,1,13.142,13.142Z",
    transform: "translate(-35.514 -29.132)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_921",
    "data-name": "Rectangle 921",
    width: 127.814,
    height: 112.339,
    transform: "translate(202.952 148.491)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_922",
    "data-name": "Rectangle 922",
    width: 124.846,
    height: 101.489,
    transform: "translate(204.419 156.9)",
    fill: "#352628"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_923",
    "data-name": "Rectangle 923",
    width: 122.9,
    height: 99.898,
    transform: "translate(205.392 157.7)",
    fill: "#443637"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_924",
    "data-name": "Rectangle 924",
    width: 4.337,
    height: 3.924,
    transform: "translate(216.547 165.318)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_925",
    "data-name": "Rectangle 925",
    width: 24.527,
    height: 3.924,
    transform: "translate(222.656 165.318)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_926",
    "data-name": "Rectangle 926",
    width: 16.027,
    height: 3.924,
    transform: "translate(251.346 165.318)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_927",
    "data-name": "Rectangle 927",
    width: 16.472,
    height: 3.924,
    transform: "translate(220.619 172.301)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_928",
    "data-name": "Rectangle 928",
    width: 14.98,
    height: 3.933,
    transform: "translate(238.543 180.158)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_929",
    "data-name": "Rectangle 929",
    width: 14.98,
    height: 3.933,
    transform: "translate(256.516 180.158)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_930",
    "data-name": "Rectangle 930",
    width: 2.712,
    height: 3.933,
    transform: "translate(274.043 180.158)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_931",
    "data-name": "Rectangle 931",
    width: 4.345,
    height: 3.933,
    transform: "translate(278.866 180.158)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_932",
    "data-name": "Rectangle 932",
    width: 22.672,
    height: 3.924,
    transform: "translate(262.946 172.301)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_933",
    "data-name": "Rectangle 933",
    width: 18.946,
    height: 3.924,
    transform: "translate(240.101 172.301)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_934",
    "data-name": "Rectangle 934",
    width: 22.664,
    height: 3.933,
    transform: "translate(225.756 186.992)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_935",
    "data-name": "Rectangle 935",
    width: 6.554,
    height: 3.924,
    transform: "translate(225.756 194.173)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_936",
    "data-name": "Rectangle 936",
    width: 11.509,
    height: 3.924,
    transform: "translate(235.138 194.173)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_937",
    "data-name": "Rectangle 937",
    width: 8.673,
    height: 3.924,
    transform: "translate(251.429 194.173)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_938",
    "data-name": "Rectangle 938",
    width: 8.673,
    height: 3.924,
    transform: "translate(262.237 194.173)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_939",
    "data-name": "Rectangle 939",
    width: 11.336,
    height: 3.933,
    transform: "translate(233.374 201.61)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_940",
    "data-name": "Rectangle 940",
    width: 36.482,
    height: 3.933,
    transform: "translate(246.119 201.61)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_941",
    "data-name": "Rectangle 941",
    width: 11.336,
    height: 3.933,
    transform: "translate(225.756 209.046)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_942",
    "data-name": "Rectangle 942",
    width: 5.664,
    height: 3.933,
    transform: "translate(239.211 209.046)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_943",
    "data-name": "Rectangle 943",
    width: 20.191,
    height: 3.933,
    transform: "translate(247.892 209.046)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_944",
    "data-name": "Rectangle 944",
    width: 6.2,
    height: 3.933,
    transform: "translate(234.783 216.483)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_945",
    "data-name": "Rectangle 945",
    width: 2.655,
    height: 3.933,
    transform: "translate(243.11 216.483)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_946",
    "data-name": "Rectangle 946",
    width: 6.901,
    height: 3.933,
    transform: "translate(249.129 216.483)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_947",
    "data-name": "Rectangle 947",
    width: 16.472,
    height: 3.933,
    transform: "translate(257.983 216.483)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_948",
    "data-name": "Rectangle 948",
    width: 8.319,
    height: 3.933,
    transform: "translate(276.756 216.483)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_949",
    "data-name": "Rectangle 949",
    width: 25.5,
    height: 3.933,
    transform: "translate(287.202 216.483)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_950",
    "data-name": "Rectangle 950",
    width: 11.336,
    height: 3.924,
    transform: "translate(234.783 223.919)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_951",
    "data-name": "Rectangle 951",
    width: 7.618,
    height: 3.924,
    transform: "translate(249.665 223.919)",
    fill: "#c3c640"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_952",
    "data-name": "Rectangle 952",
    width: 7.618,
    height: 3.924,
    transform: "translate(260.292 223.919)",
    fill: "#c3c640"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_953",
    "data-name": "Rectangle 953",
    width: 28.509,
    height: 3.933,
    transform: "translate(234.783 231.356)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_954",
    "data-name": "Rectangle 954",
    width: 15.046,
    height: 3.933,
    transform: "translate(265.774 231.356)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_955",
    "data-name": "Rectangle 955",
    width: 11.336,
    height: 3.933,
    transform: "translate(225.756 238.792)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_956",
    "data-name": "Rectangle 956",
    width: 8.146,
    height: 3.933,
    transform: "translate(240.101 238.792)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_957",
    "data-name": "Rectangle 957",
    width: 19.564,
    height: 3.933,
    transform: "translate(250.728 238.792)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_958",
    "data-name": "Rectangle 958",
    width: 9.737,
    height: 3.933,
    transform: "translate(271.71 238.792)",
    fill: "#c3c640"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_959",
    "data-name": "Rectangle 959",
    width: 24.618,
    height: 3.933,
    transform: "translate(283.129 238.792)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_960",
    "data-name": "Rectangle 960",
    width: 11.336,
    height: 3.933,
    transform: "translate(234.783 246.229)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_961",
    "data-name": "Rectangle 961",
    width: 9.209,
    height: 3.933,
    transform: "translate(249.928 246.229)",
    fill: "#c3c640"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_962",
    "data-name": "Rectangle 962",
    width: 5.936,
    height: 3.933,
    transform: "translate(262.501 246.229)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_963",
    "data-name": "Rectangle 963",
    width: 20.809,
    height: 3.933,
    transform: "translate(271.801 246.229)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_964",
    "data-name": "Rectangle 964",
    width: 5.936,
    height: 3.933,
    transform: "translate(294.91 246.229)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_965",
    "data-name": "Rectangle 965",
    width: 6.373,
    height: 3.933,
    transform: "translate(252.674 186.992)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2111",
    "data-name": "Path 2111",
    d: "M376.89,184.884a1.773,1.773,0,1,0,1.773-1.764,1.772,1.772,0,0,0-1.773,1.764Z",
    transform: "translate(-66.134 -32.148)",
    fill: "#c3c640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2112",
    "data-name": "Path 2112",
    d: "M385.27,184.884a1.773,1.773,0,1,0,1.773-1.764,1.773,1.773,0,0,0-1.773,1.764Z",
    transform: "translate(-67.605 -32.148)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2113",
    "data-name": "Path 2113",
    d: "M393.65,184.884a1.773,1.773,0,1,0,1.764-1.764,1.773,1.773,0,0,0-1.764,1.764Z",
    transform: "translate(-69.076 -32.148)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_966",
    "data-name": "Rectangle 966",
    width: 79.007,
    height: 20.051,
    transform: "translate(227.355 268.456)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_967",
    "data-name": "Rectangle 967",
    width: 269.412,
    height: 165.136,
    rx: 15.94,
    transform: "translate(96.029 136.808)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2114",
    "data-name": "Path 2114",
    d: "M291.132,333.128a3.627,3.627,0,0,1,1.418,2.325h-2.4a1.83,1.83,0,0,0-.725-.824,2.234,2.234,0,0,0-1.179-.3,2.193,2.193,0,0,0-1.723.726,3.3,3.3,0,0,0,0,4,2.547,2.547,0,0,0,1.937.717,2.308,2.308,0,0,0,2.284-1.707h-2.861v-1.649h4.749v2.242a4.386,4.386,0,0,1-2.333,2.663,4.74,4.74,0,0,1-2.069.437,5,5,0,0,1-2.473-.6,4.122,4.122,0,0,1-1.649-1.69,5.606,5.606,0,0,1,0-4.947,4.122,4.122,0,0,1,1.649-1.69,4.947,4.947,0,0,1,2.473-.6A4.65,4.65,0,0,1,291.132,333.128Z",
    transform: "translate(-49.745 -58.324)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2115",
    "data-name": "Path 2115",
    d: "M298.419,334.186v2h3.166v1.649h-3.166v2.078h3.562v1.814H296.16V332.38h5.821v1.806Z",
    transform: "translate(-51.961 -58.351)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2116",
    "data-name": "Path 2116",
    d: "M313.1,341.746h-2.267l-3.784-5.771v5.771H304.78V332.38h2.267l3.784,5.771V332.38H313.1Z",
    transform: "translate(-53.475 -58.351)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2117",
    "data-name": "Path 2117",
    d: "M319.027,334.186v2h3.166v1.649h-3.166v2.078h3.562v1.814H316.76V332.38h5.829v1.806Z",
    transform: "translate(-55.578 -58.351)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2118",
    "data-name": "Path 2118",
    d: "M330.2,341.745l-2.028-3.537h-.511v3.537H325.39V332.38h3.867a4.172,4.172,0,0,1,1.88.387,2.663,2.663,0,0,1,1.154,1.055,3.009,3.009,0,0,1,.379,1.525,2.7,2.7,0,0,1-.561,1.74,2.911,2.911,0,0,1-1.649.981l2.226,3.677Zm-2.539-5.087h1.4a1.393,1.393,0,0,0,.989-.3,1.146,1.146,0,0,0,.322-.882,1.179,1.179,0,0,0-.322-.874,1.393,1.393,0,0,0-.989-.313h-1.4Z",
    transform: "translate(-57.093 -58.351)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2119",
    "data-name": "Path 2119",
    d: "M341.262,340.053H337.75l-.577,1.707H334.79l3.471-9.3h2.605l3.43,9.3h-2.407Zm-.585-1.723-1.162-3.446-1.179,3.446Z",
    transform: "translate(-58.743 -58.365)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2120",
    "data-name": "Path 2120",
    d: "M353.928,332.38v1.806h-2.539v7.56H349.1v-7.56H346.59V332.38Z",
    transform: "translate(-60.815 -58.351)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2121",
    "data-name": "Path 2121",
    d: "M358.909,334.186v2h3.166v1.649h-3.166v2.078h3.562v1.814H356.65V332.38h5.821v1.806Z",
    transform: "translate(-62.581 -58.351)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_258",
    "data-name": "Ellipse 258",
    cx: 21.584,
    cy: 21.584,
    rx: 21.584,
    ry: 21.584,
    transform: "translate(110.424 154.641)",
    fill: "#007cff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2122",
    "data-name": "Path 2122",
    d: "M109.2,389.337s-9.737-11.353-.6-18.566c0,0,6.67-4.04,12.111-3.71,0,0-7.709,12.927-5.219,14.213s7.593-15.021,7.593-15.021,15.178-1.476,20.067.874c0,0-12.977,10.619-10.248,11.254s16.753-9.794,16.753-9.794,14.131,2.407,13.372,11.023-5.664,11.287-7.791,11.089-14.659-5.013-14.931-3.257,7.263,7.486,12.54,7.75c0,0-9.959,10.99-16.58,7.816s-7.189-8.195-11.311-10.083-7.651-1.88-5.952,0,9.176,3.792,11.542,7.972,4.477,6.983-2.374,5.952-17.981-6.043-18.468-11.781Z",
    transform: "translate(-18.348 -64.217)",
    fill: "#599dad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2123",
    "data-name": "Path 2123",
    d: "M155.206,382.816s-38.37-1.476-46.845,9.5a27.825,27.825,0,0,1-7.643,10.718l-.9,2.473s6.645-7.008,9.069-7.42C108.831,398.052,105.113,384.457,155.206,382.816Z",
    transform: "translate(-17.493 -67.194)",
    fill: "#599dad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2124",
    "data-name": "Path 2124",
    d: "M99.013,407.157A24.143,24.143,0,0,0,90.2,424.174l1.5.132s2.63-11.254,7.42-15.664S99.013,407.157,99.013,407.157Z",
    transform: "translate(-15.804 -71.311)",
    fill: "#599dad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2125",
    "data-name": "Path 2125",
    d: "M56.781,368.473s15.483-8.665,8.244-20.438c0,0-5.771-7.222-11.979-9.069,0,0,3.3,17.544,0,17.956s-2.267-19.787-2.267-19.787-16.308-7.84-22.705-7.222c0,0,10.116,17.132,6.81,16.72S20.242,328.9,20.242,328.9,3.522,325.767.818,335.677s1.649,14.84,4.122,15.483,18.377.412,17.965,2.473-11.122,5.375-17.14,3.512c0,0,6.6,16.307,15.269,15.483s11.361-6.192,16.728-6.6,9.283,1.031,6.6,2.473-11.765.478-16.1,4.163-7.849,5.953.206,7.6,22.5.627,25.393-5.573Z",
    transform: "translate(0.037 -57.658)",
    fill: "#6bb7bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2126",
    "data-name": "Path 2126",
    d: "M10.29,341s43.349,14.016,48.3,29.68a32.92,32.92,0,0,0,4.122,15.071v3.1s-4.543-10.528-7.016-11.979C55.709,376.9,65.412,363.26,10.29,341Z",
    transform: "translate(-1.776 -59.864)",
    fill: "#6bb7bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2127",
    "data-name": "Path 2127",
    d: "M73.45,394.9s6.686,10.149,2.877,22.507l-1.723-.462s1.649-13.612-1.83-20.454S73.45,394.9,73.45,394.9Z",
    transform: "translate(-12.501 -68.989)",
    fill: "#6bb7bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2128",
    "data-name": "Path 2128",
    d: "M95.9,351.274S75.49,339.847,85.02,324.331c0,0,7.618-9.522,15.78-11.971,0,0-4.353,23.134,0,23.678s2.993-26.127,2.993-26.127,21.493-10.339,29.936-9.522c0,0-13.34,22.582-8.986,22.037s19.325-23.4,19.325-23.4,22.037-4.122,25.558,8.978-2.177,19.589-5.441,20.4-24.214.544-23.67,3.3,14.692,7.074,22.582,4.625c0,0-8.706,21.493-20.133,20.405s-14.972-8.162-22.046-8.706-12.243,1.36-8.706,3.3,15.508.627,21.229,5.483,10.339,7.849-.272,10.025-29.68.824-33.472-7.346Z",
    transform: "translate(-14.45 -52.388)",
    fill: "#86d1cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2129",
    "data-name": "Path 2129",
    d: "M161.283,315s-57.142,18.5-63.672,39.186a43.4,43.4,0,0,1-5.441,19.861v4.081s5.985-13.875,9.25-15.78C101.412,362.348,88.625,344.391,161.283,315Z",
    transform: "translate(-16.15 -55.3)",
    fill: "#6bb7bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2130",
    "data-name": "Path 2130",
    d: "M91.023,386.081s-8.813,13.389-3.792,29.68l2.267-.6s-2.2-17.948,2.407-26.968S91.023,386.081,91.023,386.081Z",
    transform: "translate(-15.011 -67.335)",
    fill: "#6bb7bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2131",
    "data-name": "Path 2131",
    d: "M89.4,456.953A39.977,39.977,0,0,0,129.381,417H49.41A39.977,39.977,0,0,0,89.4,456.953Z",
    transform: "translate(-8.643 -73.206)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2132",
    "data-name": "Path 2132",
    d: "M100.289,456.648A40.018,40.018,0,0,1,55.34,417h9.893a39.986,39.986,0,0,0,35.055,39.648Z",
    transform: "translate(-9.684 -73.206)",
    fill: "#ffc294"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2133",
    "data-name": "Path 2133",
    d: "M129.819,466.877H48.76a4.947,4.947,0,0,1,4.947-4.947h71.183a4.947,4.947,0,0,1,4.947,4.947Z",
    transform: "translate(-8.529 -81.094)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_968",
    "data-name": "Rectangle 968",
    width: 82.181,
    height: 1.228,
    transform: "translate(39.472 343.769)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2134",
    "data-name": "Path 2134",
    d: "M345.5,226.62s8.154,7.206,32.846,6.793,41.461-10.322,48.527-20.512,8.962-25.129,11.377-26.242,3.125,1.773,2.993,6.249-2.168,23.777-3.529,40.348a219.753,219.753,0,0,1-3.809,27.446,182.408,182.408,0,0,0,30.727,5.046l.569.041.544.049c17.627,1.36,28.658-2.473,28.905-2.531v-.536h0c0-4.493.4-11.542.519-13.488v-.511l.668-.19c31.444-8.855,35.3-26.844,31.659-45.864-3.669-19.152-8.558-30.966-21.056-36.127-8.615-3.562-20.1-4.493-27.322-4.757h-.544c-2.976-.091-5.145-.082-5.961-.107-1.871-.074-3.677-.115-5.417-.14h-.544c-39.573-.412-45.081,10.635-50,19.836-5.161,9.646-13.043,23.5-24.321,29.078s-41.428,5.573-41.428,5.573a30.825,30.825,0,0,0-5.4,10.545ZM498.632,224.7h0v-.767c.181-3.537,1.261-14.84,2-20.694.824-6.389.956-11.015,3-11.015s5.013,13.191,4.337,20.652C507.314,220.115,499.2,224.41,498.632,224.7Z",
    transform: "translate(-60.623 -28.366)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2135",
    "data-name": "Path 2135",
    d: "M518.949,494.136c2.053.824,8.244,3.059,8.088,5.326s-12.87.725-20.067-4.122C511.76,492.776,517.44,493.8,518.949,494.136Z",
    transform: "translate(-88.97 -86.663)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2136",
    "data-name": "Path 2136",
    d: "M423.625,344.325c9.069-25,22.821-62.485,22.821-62.485a183.543,183.543,0,0,0,30.7,5.021c18.27,1.608,29.762-2.358,30.018-2.473-.082,4.9,1.278,39.062,1.22,58.536-.058,18.2-1.212,51.346-2.3,69.319-.981,16.134-2.581,44.8-2.581,44.8l-.387-.091c-1.509-.338-7.189-1.36-11.979,1.212,0,0-4.485-51.759-6.381-76.484s-5.161-52.245-6.117-59.063-3.257-14.156-6.513-10.759-15.755,28.8-21.188,39.524-10.6,22.829-9.382,29.614,7.618,34.289,8.83,48.824-.948,26.308-1.352,26.646c0,0-12.762-.3-12.993-.231-.074-.2-11.831-44.94-15.8-58.8C415.752,381.812,414.49,369.314,423.625,344.325Z",
    transform: "translate(-73.139 -49.478)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2137",
    "data-name": "Path 2137",
    d: "M438.342,493.37c.074.256,12.845.33,12.993.231-.082.47-.511,4.947-10.718,6.241s-10.718-.956-10.718-1.566C429.983,497.022,433.965,494.953,438.342,493.37Z",
    transform: "translate(-75.44 -86.614)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2138",
    "data-name": "Path 2138",
    d: "M503.241,157.428a49.737,49.737,0,0,1-1.649,5.1c-.585.973-3.075.511-3.232,0s.066-3.883-.091-5.153h0a7.543,7.543,0,0,0,4.971.058Z",
    transform: "translate(-87.443 -27.627)",
    fill: "#f4a188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2139",
    "data-name": "Path 2139",
    d: "M486.814,140.721a24.034,24.034,0,0,0,1.822,4.345,15.455,15.455,0,0,0,1.336,2.078,12.886,12.886,0,0,0,6.06,4.683,7.42,7.42,0,0,0,4.947.074,6.983,6.983,0,0,0,3.825-3.529c3.3-6.464,3.38-7.915,3.38-7.915a4,4,0,0,0,3.3-3.941c.107-1.443-.264-2.341-.824-2.745a6.316,6.316,0,0,1-1.2,2.976c-1.336,1.22-2.267-2.012-3.083-3.867s-6.422-4.609-13.859-5.54a27.009,27.009,0,0,1-6.134-1.41C485.512,128.041,484.7,134.174,486.814,140.721Z",
    transform: "translate(-85.196 -22.108)",
    fill: "#f4a188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2140",
    "data-name": "Path 2140",
    d: "M509.7,122.733c-1.369-3.5-8.088-11.394-18.294-8.739a6.473,6.473,0,0,1-5.309-.486c-1.624-1.006-4.386-.173-5.1,4.04-.486,2.836,1.187,4.848,4.609,6.15a27.207,27.207,0,0,0,6.126,1.377c7.42.94,13.026,3.685,13.851,5.54s1.748,5.112,3.1,3.875a6.364,6.364,0,0,0,1.2-2.968C510.468,128.826,510.592,125.017,509.7,122.733Z",
    transform: "translate(-84.397 -19.859)",
    fill: "#000170"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2141",
    "data-name": "Path 2141",
    d: "M446.28,278.386l27.586,1.558,2.292-40.736L448.58,237.65Z",
    transform: "translate(-78.316 -41.721)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2142",
    "data-name": "Path 2142",
    d: "M484.088,257.555s-3.149-.412-5.895-.824c-3.446-.478-3.3,1.039-2.292,1.855a14.5,14.5,0,0,0,3.933,1.542s-8.088-1.27-8.244.544,8.244,2.646,8.244,2.646-8.244-.478-8.244,1.154,8.368,1.764,8.368,1.764-5.161-.132-5.161,1.4,8.038,1.723,9.308,1.649a41.05,41.05,0,0,0,0-11.41Z",
    transform: "translate(-82.759 -45.054)",
    fill: "#f4a188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2143",
    "data-name": "Path 2143",
    d: "M349.439,226.14a13.232,13.232,0,0,0-4.839-4.716c-3.364-1.9-7.527-3.075-7.61-1.649s4.246,4.526,4.246,4.526-3.529,3.628-3.4,7.807c0,0,4.708,4.04,6.175,4.592C344.006,236.726,344.682,232.653,349.439,226.14Z",
    transform: "translate(-59.129 -38.471)",
    fill: "#f4a188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2144",
    "data-name": "Path 2144",
    d: "M341.042,228.832c-.6,1.245-6.068-2.028-5.705-3.661S341.858,227.151,341.042,228.832Z",
    transform: "translate(-58.836 -39.457)",
    fill: "#f4a795"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2145",
    "data-name": "Path 2145",
    d: "M339.617,231.463c-.6,1.237-7.016-2.869-5.647-4.221S340.375,229.921,339.617,231.463Z",
    transform: "translate(-58.566 -39.846)",
    fill: "#f4a795"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2146",
    "data-name": "Path 2146",
    d: "M338.505,233.774c-.511,1.08-6.6-2.473-5.351-3.858S339.231,232.232,338.505,233.774Z",
    transform: "translate(-58.427 -40.309)",
    fill: "#f4a795"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2147",
    "data-name": "Path 2147",
    d: "M312.377,200.967a.453.453,0,0,0,.058.643l25.7,21.5a.453.453,0,0,0,.635-.058h0a.453.453,0,0,0-.058-.635l-25.7-21.5a.462.462,0,0,0-.635.049Z",
    transform: "translate(-54.79 -35.254)",
    fill: "#99a6ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2148",
    "data-name": "Path 2148",
    d: "M342.234,226.113c-.907,1.649-5.771-1.649-5.252-3.075S343.132,224.489,342.234,226.113Z",
    transform: "translate(-59.121 -39.088)",
    fill: "#f4a795"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2149",
    "data-name": "Path 2149",
    d: "M526.862,200.48s-9.209,37.2-40.612,47.818c0,0,18.608-1.4,37.051-16.753Z",
    transform: "translate(-85.333 -35.195)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2150",
    "data-name": "Path 2150",
    d: "M518.79,267.33s-.594,11.023-.552,14.543a76.673,76.673,0,0,1-38.378,1.542l.684-12.218h5.029S506.251,272.524,518.79,267.33Z",
    transform: "translate(-84.211 -46.931)",
    fill: "#ed7d2b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateCode);
export default __webpack_public_path__ + "static/media/generate-code.1b1f84d101b3ab18f3cbbcf39d954c5d.svg";
export { ForwardRef as ReactComponent };